<template>
    <div class="bg-white px-4 py-5 sm:p-6">
      <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
        <div class="text-xl font-bold"> levantar Embargo Personas</div>
        <button @click="$emit('updateValues', {'view': 'listar'});"
                class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
          </svg>
          <span class="ml-3">Volver</span>
        </button>
      </div>
      <div class="grid grid-cols-6 gap-6" > 
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="num_titulo" class="block text-sm font-medium text-gray-700">Número Oficio <span style="color: red">(*)</span></label>
          <input type="number" id="num_titulo" v-model="numero_oficio" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
  
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_oficio" class="block text-sm font-medium text-gray-700">Fecha Oficio <span style="color: red">(*)</span></label>
          <input type="date" id="fecha_oficio"  v-model="fecha_oficio" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>

        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="valor" class="block text-sm font-medium text-gray-700">Valor <span style="color: red">(*)</span></label>
          <input type="text" id="valor" v-model="valor" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" style="background-color: #f3f3f3;"  disabled>
        </div>

        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="concepto_levantamiento" class="block text-sm font-medium text-gray-700">Concepto del levantamiento <span style="color: red">(*)</span></label>
          <select id="concepto_levantamiento" v-model="concepto_levantamiento" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            <option value="" disabled>Seleccione un concepto</option>
            <option value="pago_total">Pago total</option>
            <option value="desistimiento">Desistimiento</option>
            <option value="caducidad">Caducidad</option>
            <option value="otro">Otro</option>
          </select>
        </div>

        <div v-if="concepto_levantamiento === 'otro'" class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="concepto_otro" class="block text-sm font-medium text-gray-700">¿Cuál? <span style="color: red">(*)</span></label>
          <input type="text" id="concepto_otro" v-model="concepto_otro" maxlength="255" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>

        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label class="block text-sm mb-1 font-medium text-gray-700">Cargue de soporte </label>
          <div class="max-w-xl mb-3" id="cargue_archivo_embargos">
            <label style="min-height: 8rem;" for="archivo"
                  class="flex justify-center w-full transition bg-white border-2 border-gray-300 border-dashed rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
              <span ref="fileFormEnter" id="contenedor_archivo" class="flex items-center space-x-2 w-full">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-gray-600 grow" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                </svg>
                <span class="font-medium text-gray-600 grow">
                Arrastra el archivo aquí, o
                <span class="text-blue-600 underline">abre el explorador</span>
                </span>
              </span>
              <span ref="fileFormDrop" id="drag_over" class="hidden">
                <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600 grow"
                    fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
                </svg>
              </span>
              <span ref="fileFormUploaded" id="info_archivo" :class="documentoSoporte? 'font-bold block w-full flex flex-col justify-center align-middle gap-3 px-3' : 'hidden'">
                <img id="preview_archivo" src="" alt=""/>
                <span class="flex justify-center align-middle gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" class="self-center w-6 h-6 inline-block text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"/>
                  </svg>
                  <span id="nombre_archivo" class="self-center"></span>
                </span>
              </span>
              <input type="file" id="archivo" class="hidden" @change="
                uploadFile(document.getElementById('archivo').files.item(0));
                documentoSoporte=document.getElementById('archivo').files.item(0); ">
            </label>
          </div>
          <div v-if="data.levantamientos[0] != null">
            <button v-if="data.levantamientos[0].soportes.length > 0"
                    @click="descargarDocumentoSoporte(data.levantamientos[0].soportes[0].url_soporte)"
                    class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="inline-block w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
                </svg>
              <span class="ml-3">Descargar documento de soporte</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="customSaveData()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
       v-text=" !data.levantamientos[0] ?'Guardar':'Actualizar'">
      </button>
    </div>
  </template>
  
  <script>
  import {saveUpdateData} from "@/layouts/main";
  import Swal from "sweetalert2";
  import { ref } from "vue";
  import { uploadFile, useAPIRest, enableUploadFileByDragger, removeFile, swal, generateTextError, verifyHttpCode, separateNumberByCommaInput } from "@/common/constants"; 
  import mime from "mime";
  import { v4 as uuidv4 } from 'uuid';

  export default {  
    name: 'LevantarEmbargoPersonasComponent',
    props: ['view',  'authToken', 'customUpdateValueData', 'data' , 'entity' ],
    emits: ["updateValues",'customSaveData'],
    async setup(props, {emit} ) {

      const fecha_oficio = ref((props.data.levantamientos[0] ) ? props.data.levantamientos[0].fecha_oficio : '');
      const numero_oficio = ref((props.data.levantamientos[0] ) ? props.data.levantamientos[0].numero_oficio : '');
      const valor = ref((props.data.levantamientos[0] ) ? separateNumberByCommaInput(props.data.levantamientos[0].valor) :  separateNumberByCommaInput(props.data.valor_actual));
      const concepto_levantamiento = ref((props.data.levantamientos[0] ) ? (props.data.levantamientos[0].concepto_levantamiento || '') : '');
      const concepto_otro = ref((props.data.levantamientos[0] ) ? (props.data.levantamientos[0].concepto_otro || '') : '');
      const documentoSoporte = ref('');

      const customSaveData = async () =>  {
        try {
          
          const dataSave = {
            id_embargo_persona : props.data.id,
            fecha_oficio: fecha_oficio.value,
            numero_oficio: numero_oficio.value,
            valor: Math.floor(valor.value.replaceAll(',','')),
            concepto_levantamiento: concepto_levantamiento.value,
            concepto_otro: concepto_levantamiento.value === 'otro' ? concepto_otro.value : null
          }
          const nameCompletoFields = {
            fecha_oficio: 'fecha de oficio',
            numero_oficio: 'número de oficio',
            valor: 'valor',
            concepto_levantamiento: 'concepto del levantamiento'
          }

          let error = '';
          for ( let key in nameCompletoFields){
            if(dataSave[key] == ''){
              error += `El campo ${ nameCompletoFields[key] } es obligatorio! <br>`;
            }
          }

          if (concepto_levantamiento.value === 'otro' && !concepto_otro.value) {
            error += `Debe especificarse el concepto cuando se selecciona Otro! <br>`;
          }

          if(error != ''){
            Swal.fire({
              title: error,
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
          }

          let listApi = {
            create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE_LEVANTAMIENTO,
            update : process.env.VUE_APP_NEST_EMBARGOPERSONA_UPDATE_LEVANTAMIENTO,
            list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL,
          };

          const newLoadData = new FormData();
          let validDocumentoSoporte = false;

          /**
           Valida el tamaño del archivo de soporte y lo agrega al FormData si es válido.
          */
          
          if (documentoSoporte.value) {
            const pesoMaximo = 10 * 1024 * 1024;
            if (documentoSoporte.value.size > pesoMaximo) {
              validDocumentoSoporte = false;
              removeFile(document.getElementById('cargue_archivo_embargos'));
              documentoSoporte.value = undefined;
              await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
              return;
            } else{

              validDocumentoSoporte = true;
              const uniqueFilename = `${uuidv4()}-${documentoSoporte.value.name}`;
              newLoadData.append('file', documentoSoporte.value, uniqueFilename);
            }
          }


          const resJSON = await saveUpdateData({
            listApi,
            authToken: props.authToken,
            loadData: dataSave,
            selectedData: (props.data.levantamientos[0]) ? { id : props.data.levantamientos[0].id } : {},
            action: (!props.data.levantamientos[0]) ? 'crear' : 'actualizar',
            entity: props.entity,
            view: (!props.data.levantamientos[0]) ? 'crear' : 'actualizar',
          }, emit, false, false, (!validDocumentoSoporte) ? false : true);
          
          if(resJSON.statusCode == 200 || resJSON.statusCode == 201){
            console.log('resJSON',resJSON);

            listApi = {
              create: process.env.VUE_APP_NEST_EMBARGOPERSONA_CREATE_SOPORTE_LEVANTAMIENTO,
              list: process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL,
            };
            
            newLoadData.append('id_levantamiento_embargos_persona', resJSON.id);            
            
            console.log('validDocumentoSoporte',validDocumentoSoporte);
            if (validDocumentoSoporte){              
              await saveUpdateData({
                listApi,
                authToken: props.authToken,
                loadData: newLoadData,
                action: 'crear',
                entity: props.entity,
                view: 'crear',
                options: {
                  save: {
                    contentType: 'auto'
                  },
                  update: {
                    contentType: 'auto'
                  }
                }
              }, emit, true, false, false);
            }
          }
                  
        }catch (error) {
          Swal.fire({
              title: 'Error al guardar',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
          console.error('Error al guardar:', error);
        }
      }
  
      return {
        documentoSoporte,
        document: document,
        uploadFile : uploadFile,
        console : console,
        customSaveData,
        fecha_oficio,
        numero_oficio,
        valor,
        concepto_levantamiento,
        concepto_otro,
      }
    },
    watch: {
      "documentoSoporte": function (documentoSoporte) {
        if (documentoSoporte) {
          if (window.navigator.userAgent.includes("Firefox")) {
            const name = documentoSoporte.name;
            const mimeType = documentoSoporte.type;
            const lastDot = name.lastIndexOf('.');
            const fileName = name.substring(0, lastDot);
            const ext = name.substring(lastDot + 1);
            if (ext === 'csv' && mimeType !== 'text/csv') this.documentoSoporte = new File([documentoSoporte], `${fileName}.${ext}`, {type: 'text/csv'});
          }
        }
      },
    },
    methods: {
      async descargarDocumentoSoporte(fileName) {
        await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_OBTENERARCHIVO_LEVANTAMIENTO, 'GET', this.authToken, undefined, {
          'url': fileName
        }).then(async resJSON => {
          const {statusCode} = resJSON;
          delete resJSON.statusCode;
          const textoError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) {
            const blob = await resJSON.blob();
            const newBlob = new Blob([blob], {type: mime.getType(fileName)});
            const url = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.replace('src/assets/documentos_soporte_embargos/personas/', ''));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else await swal.fire(textoError, '', 'error');
        });
      },
    },
    mounted() {
      enableUploadFileByDragger(this, 'documentoSoporte')
      if(this.documentoSoporte){
        uploadFile(this.documentoSoporte);
      }
    },
  
  }
  </script>